module.exports = __webpack_public_path__ + "static/media/boquilla4.ecc368fe.png";